import { MIGRATION } from "../config/lumacofono";

// localStorage is per-origin: these keys are carried to the new subdomain through a one-time link (#trasferisci=...).
const KEYS = { best: "ctlc-best-island", history: "ctlc-history", player: "ctlc-player" };
const HASH = "#trasferisci=";
const MAX_INDEX = 22;

const isIndex = (v) => Number.isInteger(v) && v >= 0 && v <= MAX_INDEX;

const readLocal = () => ({
  best: localStorage.getItem(KEYS.best),
  history: localStorage.getItem(KEYS.history),
  player: localStorage.getItem(KEYS.player),
});

export const shouldOfferTransfer = () => {
  if (!MIGRATION.enabled) return false;
  if (window.location.origin === MIGRATION.targetOrigin) return false;
  return Object.values(readLocal()).some((v) => v !== null);
};

export const buildTransferUrl = () => {
  const payload = JSON.stringify(readLocal());
  return `${MIGRATION.targetOrigin}/${HASH}${encodeURIComponent(btoa(payload))}`;
};

const parsePayload = (raw) => {
  const data = JSON.parse(atob(decodeURIComponent(raw)));
  const best = data.best === null ? null : Number(data.best);
  const history = data.history ? JSON.parse(data.history) : [];
  return {
    best: isIndex(best) ? best : null,
    history: Array.isArray(history) ? history.filter(isIndex).slice(0, 5) : [],
    player: typeof data.player === "string" && /^[\w-]{8,64}$/.test(data.player) ? data.player : null,
  };
};

// Merges transferred data without deleting anything already saved here; returns true if a transfer was applied.
export const importTransfer = () => {
  const { hash, pathname, search } = window.location;
  if (!hash.startsWith(HASH)) return false;
  window.history.replaceState(null, "", pathname + search);
  try {
    const incoming = parsePayload(hash.slice(HASH.length));
    const local = readLocal();
    if (incoming.best !== null) {
      const merged = local.best === null ? incoming.best : Math.max(Number(local.best), incoming.best);
      localStorage.setItem(KEYS.best, String(merged));
    }
    const localHistory = local.history ? JSON.parse(local.history) : [];
    localStorage.setItem(KEYS.history, JSON.stringify([...localHistory, ...incoming.history].slice(0, 5)));
    if (incoming.player && !local.player) localStorage.setItem(KEYS.player, incoming.player);
    return true;
  } catch {
    return false;
  }
};
